
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Memory from "dojo/store/Memory";
import Query from "csi/xml/Query";
import Relationship from "csi/def/Relationship";
import Action from "csi/def/Action";
import FormWidget from "csi/form/Widget";
import locale from "csi/locale";
import StoreNamesConstructor from "csi/store/Names";
import csiStore from "csi/store/_base";
import xml from "csi/xml";
import ViewRef from "csi/def/ViewRef";

const FIELD_SCOPE = "FormulatedMaterialMassReplaceScope";
const FIELD_TO = "FormulatedMaterialMassReplaceTo";

const SCOPE_FORMULATED_MATERIAL = "FormulatedMaterial";

const MassReplaceFormulatedMaterialForm = declare(FormWidget, {
	/** @property {Store} _storeFormulatedMaterial - field store for FormulatedMaterials */
	_storeFormulatedMaterial: null,

	/**
	 * @override
	 */
	getFieldStore(field, value) {
		const name = field.getControlName();
		// Replace Types
		if (name === FIELD_SCOPE) {
			return new Memory({
				data: [
					{ id: SCOPE_FORMULATED_MATERIAL, name: locale.type("Raw Material") },
				],
			});
		}

		// From/To fields
		const scope = this.defView.getFieldValue(FIELD_SCOPE);
		if (name == FIELD_TO) {
			if (scope === SCOPE_FORMULATED_MATERIAL) {
				return this._getFormulatedMaterialStore();
			}
		}

		return this.inherited(arguments);
	},

	_getStore(r) {
		const storeOptions = { data: [csiStore.nameObject("")] };
		csiStore.namesOptionsByRelationship(this.getContext(), r, storeOptions);
		return new StoreNamesConstructor(storeOptions);
	},

	/**
	 * Populates field store for Formulated Materials
	 * @returns Formulated Materials Store
	 */
	_getFormulatedMaterialStore() {
		const formulatedMaterial = this.getViewNode();

		const formulatedMaterialsQuery = new Query()
			.Attr("Special", xml.OP_EQUALS, false)
			.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, formulatedMaterial.$URL);

		const formulatedMaterialStore = this._getStore(lang.mixin(new Relationship(), {
			m_typeNode: "FormulatedMaterial",
			m_query: formulatedMaterialsQuery,
		}));

		formulatedMaterialStore.action = lang.mixin(new Action(), {
			m_viewRef: lang.mixin(new ViewRef(), {
				m_id: "AllFormulatedMaterials",
				m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null",
			}),
			m_fixedQuery: formulatedMaterialsQuery,
		});
		this._storeFormulatedMaterial = formulatedMaterialStore;

		return this._storeFormulatedMaterial;
	},

	_resolveView() {
		this.addDefaultValue(FIELD_SCOPE, SCOPE_FORMULATED_MATERIAL);
		this.inherited(arguments);
	},
});

export = MassReplaceFormulatedMaterialForm;